/**
 * 此文件用于工具类
 */
import sysconstant from '@/utils/sysconstant'
/**
   *  返回日期格式 yyy-mm-dd
   * @param day
   * @returns {Date}
 */
let getLast = (day) => {
  let date1 = new Date()
  let date2 = new Date(date1)
  date2.setDate(date1.getDate() + day)
  return date2.Format(sysconstant.DATE_FORMATE)
}

const isEmptyObject = function (e) {
  for (let t in e) {
    return !1
  }
  return !0
}
const extraListProps = function (arr, propname) {
  if (arr) {
    let _temps = []
    for (let item of arr) {
      _temps.push(item[propname])
    }
    return _temps
  }
  return []
}
/**
 *  生成UUID
 * @returns {string}
 */
let guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

// 判断的是否是JSON字符串
const isJsonString = (str)=>{
	if (typeof str == 'string') {
    try {
      var obj = JSON.parse(str);
      // 等于这个条件说明就是JSON字符串 会返回true
      if (typeof obj == 'object' && obj) {
        return true;
      } else {
      //不是就返回false
        return false;
      }
    } catch (e) {
      return false;
    }
  }
  return false;
}
export default { getLast, isEmptyObject, extraListProps, guid, isJsonString}



// WEBPACK FOOTER //
// ./src/utils/util.js